import {UI} from "../../../stem-core/ui/UIBase";

import {InputContainer} from "./Base";
import {TimeInput} from "../../../stem-core/ui/input/Input";
import {StemDate} from "../../../stem-core/time/Date";
import {PopupInput} from "./PopupInput";
import {DateCalendarInput} from "./date-input/date-picker/DateCalendarInput";
import {BaseInputElement} from "../../../stem-core/ui/input/BaseInputElement.js";
import type {NodeAttributes} from "../../../stem-core/ui/NodeAttributes";


// TODO - cleanup this implementation
interface DateInputOptions {
    dateFormatter?: (date: StemDate) => string;
}

export class DateInput extends BaseInputElement<any, DateInputOptions> {
    getDefaultOptions(options?: this["options"]) {
        return {
            ...super.getDefaultOptions(options),
            dateFormatter: (date: StemDate) => date.format("MMM DD, YYYY"), // TODO: Use something global
        }
    }

    formatDate() {
        const date = this.getValue();
        if (!date) {
            return "MMM DD, YYYY";
        }
        return this.options.dateFormatter(date);
    }

    async openDatePicker() {
        const value = await PopupInput.prompt(DateCalendarInput, {
            initialValue: this.getValue(),
        }, {anchor: this});

        if (value) {
            this.setValue(value);
        }
    }

    render() {
        return <InputContainer style={{fontWeight: 700, cursor: "pointer"}} onClick={() => this.openDatePicker()}>
            {this.formatDate()}
        </InputContainer>
    }
}

interface DateTimeInputOptions {
    initialValue?: any;
}

export class DateTimeInput extends UI.Element<DateTimeInputOptions> {
    declare dateInput: DateInput;
    declare timeInput: TimeInput;

    extraNodeAttributes(attr: NodeAttributes) {
        attr.setStyle({
            display: "inline-flex",
        });
    }

    render() {
        const {initialValue} = this.options;
        return [
            <DateInput initialValue={initialValue} ref="dateInput" />,
            <TimeInput value={initialValue} ref="timeInput" />,
        ]
    }

    getValue() {
        let date = this.dateInput.getValue();
        date = this.timeInput.getValue(date);
        return date;
    }

    setValue(date: StemDate | Date | string | number) {
        date = new StemDate(date);
        this.dateInput.setValue(date);
        this.timeInput.setValue(date);
    }
}
